import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { EditFloorPage } from "./edit-floor.page";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "src/app/_component/header/header.module";
import { ModalHeaderComponentModule } from "src/app/app/_component/modal-header/modal-header.module";
import { UploadAttachmentModule } from "../../_component/upload-attachment/upload-attachment.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { InputsModule } from "src/app/_component/inputs/inputs.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedDirectivesModule,
    TranslateModule,
    HeaderModule,
    ModalHeaderComponentModule,
    UploadAttachmentModule,
    InputsModule,
  ],
  declarations: [EditFloorPage],
})
export class EditFloorPageModule {}
